<div class="abort_block" [ngClass]="[showTrustlyAbortText ?'abort_block_pnp':'abort_block_non-pnp', isMobileSignUpUrl ? 'mobile_url_abort_block' : 'non_mobile_url_abort_block']">
  <h1 class="abort_block--title" *ngIf="!showTrustlyAbortText">{{'registrationAbort.nonTrustlyConfirmAbortText' | translate}}</h1>
  <div class="abort_block--text" *ngIf="!showTrustlyAbortText">{{'registrationAbort.nonTrustlyConfirmBonusText' | translate}}</div>

  <h1 class="abort_block--title" *ngIf="showTrustlyAbortText">{{'registrationAbort.trustlyConfirmAbortText' | translate}}</h1>
  <div class="abort_block--text" *ngIf="showTrustlyAbortText">{{'registrationAbort.trustlyConfirmBonusText' | translate}}</div>
  <div class="abort_block--footer">
    <button class="abort_block--go-back-btn site-btn site-btn__primary site-btn--lg" (click)="gotoStepOne()">{{'registrationAbort.cancelAbortText' | translate}}</button>
    <div class="abort_block--footer-link-parent">
      <span class="abort_block--go-home-btn" (click)="gotoHomePage()">{{'registrationAbort.continueAbortText' | translate}}</span>
    </div>
  </div>
</div>